import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UserSimulationFilter {
  userIds?: string[];
  modules?: string[];
  simulationIds?: string[];
  status?: string[];
}

export interface UserSimulationCompletedFilter {
  module: string;
  cellId: string;
  scoring: number;
  userIds?: string[];
  simulationIds?: string[];
}

export interface UserSimulationLogModel {
  event: string;
  payload?: any;
}

@Injectable({
  providedIn: 'root'
})
export class UserSimulationsService {
  private readonly baseUrl: string;
  
  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiUrl}/user-simulations`;
  }
  
  public getUserSimulations = (filter: UserSimulationFilter): Observable<any[]> => {
    if (!filter.status) {
      filter.status = ['FINISHED'];
    }
    return this.http.get<any[]>(`${this.baseUrl}`, {params: {...filter}});
  };
  
  public getCompletedUserSimulation = (filter: UserSimulationCompletedFilter): Observable<any[]> => {
    return this.http.get<any[]>(`${this.baseUrl}/completed`, {params: {...filter}});
  };
  
  public getUserSimulation = (id: string): Observable<any> => {
    return this.http.get<any>(`${this.baseUrl}/${encodeURIComponent(id)}`);
  };
  
  public updateUserSimulation = (id: string, payload: any): Observable<void> => {
    return this.http.put<void>(`${this.baseUrl}/${encodeURIComponent(id)}`, payload);
  };
  
  
  public insertUserSimulation = (payload: any): Observable<string> =>
    this.http.post(`${this.baseUrl}`, payload, {responseType: 'text'});
  
  public addUserSimulationLog = (id: string, payload: UserSimulationLogModel): Observable<void> => {
    return this.http.patch<void>(`${this.baseUrl}/${encodeURIComponent(id)}/logs`, payload);
  };
  
  public getUserSimulationLogs = (id: string): Observable<UserSimulationLogModel[]> => {
    return this.http.get<UserSimulationLogModel[]>(`${this.baseUrl}/${encodeURIComponent(id)}/logs`);
  };
}
